import { render, staticRenderFns } from "./WootReports.vue?vue&type=template&id=1074669a&"
import script from "./WootReports.vue?vue&type=script&lang=js&"
export * from "./WootReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports